'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var Icon = require('../Icon-8d79bebe.js');

var React = _interopDefault(require('react'));

require('@carbon/icon-helpers');

require('prop-types');

var Search32 = /*#__PURE__*/React.forwardRef(function Search32(props, ref) {
  return React.createElement(Icon.Icon, Icon._extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), React.createElement("path", {
    d: "M30,28.59,22.45,21A11,11,0,1,0,21,22.45L28.59,30ZM5,14a9,9,0,1,1,9,9A9,9,0,0,1,5,14Z"
  }), props.children);
});
module.exports = Search32;